'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-13d783d6.js');
var React = require('react');
var styled = require('styled-components');
var typography_index = require('../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledTextBox = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledTextBox_kzprkbf5", componentId: "sc-13gy6yr" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject([""], [""])));
var StyledPrefix = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledPrefix_kzprkbf5", componentId: "sc-8o7ojl" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    ", "\n    color: ", ";\n    line-height: 20px;\n"], ["\n    ", "\n    color: ", ";\n    line-height: 20px;\n"])), typography_index.body2, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var StyledHeader = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledHeader_kzprkbf5", componentId: "sc-1em0drp" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    ", "\n    color: ", ";\n    line-height: 25px;\n"], ["\n    ", "\n    color: ", ";\n    line-height: 25px;\n"])), typography_index.header6, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var StyledBody = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledBody_kzprkbf5", componentId: "sc-1lvm0td" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    ", "\n    color: ", ";\n    line-height: 20px;\n"], ["\n    ", "\n    color: ", ";\n    line-height: 20px;\n"])), typography_index.body2, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var StyledCta = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledCta_kzprkbf5", componentId: "sc-1524he4" })(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    ", "\n    color: ", ";\n    height: 21px;\n    line-height: 21px;\n    display: inline-block;\n    margin-bottom: 32px;\n    letter-spacing: 0.35px;\n    text-decoration: underline;\n"], ["\n    ", "\n    color: ", ";\n    height: 21px;\n    line-height: 21px;\n    display: inline-block;\n    margin-bottom: 32px;\n    letter-spacing: 0.35px;\n    text-decoration: underline;\n"])), typography_index.button, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var TextBox = function (_a) {
    var children = _a.children, props = tslib_es6.__rest(_a, ["children"]);
    return (React__default['default'].createElement(StyledTextBox, tslib_es6.__assign({}, props), children));
};
TextBox.displayName = 'TextBox';
TextBox.Prefix = StyledPrefix;
TextBox.Header = StyledHeader;
TextBox.Body = StyledBody;
TextBox.Cta = StyledCta;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.default = TextBox;
//# sourceMappingURL=index.js.map
